import { createApp } from 'vue'
import App from './App.vue'
import './css/animation.css'
import './css/styles.css'

createApp(App).mount('#app')
